
class Accordion {
  constructor(element, ...options) {
    this.defaults = {
      itemSelector: '.js-accordion-item',
      triggerSelector: '.js-accordion-item-trigger',
      contentSelector: '.js-accordion-item-content',
      currentCountSelector: '.js-current-count',
      loadMoreSelector: '.js-load-more',
      activeClass: '-is-active',
      initialHideClass: '-initial-hide',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.itemWrapperElement = this.element.querySelector(this.options.itemWrapperSelector);
    this.itemElements = [].slice.call(this.element.querySelectorAll(this.options.itemSelector));
    this.triggerElements = [].slice.call(this.element.querySelectorAll(this.options.triggerSelector));

    if(this.itemElements.length > 5) {
      this.currentCountElement = this.element.querySelector(this.options.currentCountSelector);
      this.loadMoreElement = this.element.querySelector(this.options.loadMoreSelector);
    }

    this.bindEvents();
  }

  toggleAccordion(event) {
    const contentElement = event.currentTarget.nextElementSibling;
    event.currentTarget.parentNode.classList.toggle(this.options.activeClass);

    if(contentElement.style.maxHeight) {
      contentElement.style.maxHeight = null;
    } else {
      contentElement.style.maxHeight = contentElement.scrollHeight + 'px';
    }
  }

  showMore(event) {
    event.preventDefault();
    const hiddenElements = this.element.querySelectorAll(this.options.itemSelector + '.' + this.options.initialHideClass);
    const numberShow = (hiddenElements.length <= 5) ? hiddenElements.length : 5;

    // show hidden elements
    for(let i = 0; i < numberShow; i++) {
      hiddenElements[i].classList.remove(this.options.initialHideClass);
    }

    // update counter with number of elements shown
    if(this.currentCountElement) {
      this.currentCountElement.textContent = parseInt(this.currentCountElement.textContent) + numberShow;
    }

    // hide load more button if all elements are shown
    if(hiddenElements.length <= 5) {
      this.loadMoreElement.classList.add('-is-hidden');
    }
  }

  bindEvents() {
    this.triggerElements.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleAccordion.bind(this));
    });

    if(this.loadMoreElement && this.itemElements.length > 5) {
      this.loadMoreElement.addEventListener('click', this.showMore.bind(this));
    }
  }
}
